<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import {External, M} from "../../external";

  export let steps;

  const dispatch = createEventDispatcher();

  let sortable, jqSortable;

  let onEditFields = function(idx) {
    dispatch("editStepFields", {
      step: steps[idx],
      index: idx
    });
  };

  let onEditStepSettings = function(idx) {
    dispatch("editStepSettings", {
      step: steps[idx]
    });
  };

  let onRemoveStep = function(idx) {
    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, () => {
      steps.splice(idx, 1);
      steps = steps;
      dispatch("change", steps);
    });
  };

  let onAddStep = () => {
    External.Tools.promptForInput("", M.ADD_NEW_STEP, "", name => {
      if (name.trim() === "") {
        External.Tools.showError(M.ERR_EMPTY_NAME);
        return;
      }

      steps.push({
        id: Math.random(),
        name: name,
        fields: [],
        subHeading: "",
        heading: name
      });
      steps = steps;
      dispatch("change", steps);
    });
  };

  const onStepNameChange = () => {
    dispatch("change", steps);
  };

  onMount(() => {
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: ".form-step-wrapper",
      handle: ".move-icon",
      containment: "parent",
      tolerance: "pointer",
      axis: "y",
      start: (event, ui) => {
        ui.item.data("idx", ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data("idx") || 0;
        if (newIdx !== oldIdx) {
          let elem = steps[oldIdx];
          steps.splice(oldIdx, 1);
          steps.splice(newIdx, 0, elem);
          steps = steps;
          dispatch("change", steps);
        }
      }
    });
  });

  onDestroy(() => {
    jqSortable.sortable("destroy");
    jqSortable = null;
  });
</script>

<div class="col20 f-left">
  <div class="help-text-wrapper">
    <span class="help-text" style="margin-bottom:15px;">
      {M.CREATE_FORM_STEPS}
    </span>
  </div>

  <div class="col20 f-left" bind:this={sortable}>
    {#each steps as step, idx (step)}
      <div class="form-step-wrapper flex align-center">
        <span class="move-icon button-tooltip ui-sortable-handle flex-none" data-tooltip="simpleMove"></span>
        <h3 class="step-title flex-none">{M.STEP} {idx + 1}</h3>
        <input type="text" class="step-name flex-1" bind:value={step.name} on:change={onStepNameChange} />
        <div class="buttons-wrapper flex-none">
          <a
            data-tooltip="simpleEdit"
            class="middle-button blue ml-10"
            on:click={() => {
              onEditFields(idx);
            }}>
            {M.EDIT_FIELDS}
          </a>

          <a
            on:click={() => onEditStepSettings(idx)}
            data-tooltip="settings"
            class="delete delete-icon modify button-tooltip light-gray-icon
            circle-effect">
            <i class="material-icons-outlined">settings</i>
          </a>
          <a
            on:click={() => {
              onRemoveStep(idx);
            }}
            data-tooltip="simpleDelete"
            class="delete delete-icon modify button-tooltip light-gray-icon
            circle-effect">
            <i class="material-icons-outlined">delete</i>
          </a>
        </div>
      </div>
    {/each}
  </div>
  <div class="col20 f-left mt-15 t-center mb-15">
    <a
      class="with-icon middle-button blue f-none inline-block"
      on:click={onAddStep}>
      {M.ADD_NEW_STEP}
    </a>
  </div>
</div>
